import React from 'react'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism'

const CodeBlock = ({ language, value }) => {
  return (
    <SyntaxHighlighter language={language} style={materialDark} wrapLines={true} showLineNumbers>
      {String(value).replace(/\n$/, '')}
    </SyntaxHighlighter>
  )
}

export { CodeBlock }
